import { useContext } from "react";
import { useHistory } from "react-router-dom";
import { Dataset } from "../../../api/Datasets";
import { Container } from "../../../common/panels/Container/Container";
import styles from "./Viewer.module.css";
import { DatasetDetailMweb } from "../../../mweb/DatasetDetailMWeb";
import { Viewer } from "../../../ViewerLayout/FullViewer";
import { DatasetContext } from "../../Dataset";

interface Props {
  dataset: Dataset;
  viewShared?: boolean;
}
export const ViewerFullscreen = ({ dataset, viewShared = false }: Props) => {
  const history = useHistory();
  const context = useContext(DatasetContext);

  if (context?.mWebEnabled) {
    const params = new URLSearchParams(window.location.search);
    const datasetVersion = params.get("datasetVersion");

    return (
      <DatasetDetailMweb
        dataset={dataset}
        onFullScreenToggle={() => {
          datasetVersion
            ? history.push(`${history.location.pathname.split("/viewer")[0]}?datasetVersion=${datasetVersion}`)
            : history.push(`${history.location.pathname.split("/viewer")[0]}`);
        }}
        permissions={dataset.permissions}
        viewShared={viewShared}
      />
    );
  }

  return (
    <Container
      title={"Detailed view"}
      controls={
        <div
          style={{
            display: "flex",
            flexFlow: "row nowrap",
            width: "100%",
            height: "fit-content",
            alignItems: "center",
            gap: 5,
            whiteSpace: "nowrap",
          }}
        >
          <div style={{ width: "2px", height: "100%", background: "var(--gray-200)" }}>&nbsp;</div>
          <span>Tracks:</span>
          <span className="badge" style={{ margin: 0 }}>
            {dataset.parsedMetadata?.trackCount}
          </span>
        </div>
      }
    >
      {!viewShared ? (
        <div className={styles.container}>
          <Viewer ids={[dataset.id]} />
        </div>
      ) : (
        <div style={{ display: "flex", flexFlow: "column nowrap", width: "100%", height: "100%" }}>
          <div>
            <label
              className={styles.label}
              onClick={() => {
                // history.push(route(getDetailRoute("datasets")));
                history.push(`${history.location.pathname.split("/viewer")[0]}`);
              }}
            >
              « Show details
            </label>
          </div>
          <div className={styles.container}>
            <Viewer ids={[dataset.id]} />
          </div>
        </div>
      )}
    </Container>
  );
};
